import { createContext, useContext, useState, useCallback } from 'react';
import { apiPost } from '../api/client';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(() => {
        try {
            const s = sessionStorage.getItem('user');
            return s ? JSON.parse(s) : null;
        } catch { return null; }
    });

    const login = useCallback(async (email, senha) => {
        const res = await apiPost('/api/admin/login', { email, senha });
        if (!res?.success) {
            throw new Error(res?.errors?.[0] || 'Erro ao fazer login.');
        }
        sessionStorage.setItem('access_token', res.data.access_token);
        sessionStorage.setItem('user', JSON.stringify(res.data.user));
        setUser(res.data.user);
    }, []);

    const logout = useCallback(async () => {
        try { await apiPost('/api/admin/logout'); } catch {}
        sessionStorage.clear();
        setUser(null);
    }, []);

    return (
        <AuthContext.Provider value={{ user, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
